import { render, staticRenderFns } from "./EntranceTestSchedule.vue?vue&type=template&id=1286c884&scoped=true"
import script from "./EntranceTestSchedule.vue?vue&type=script&lang=js"
export * from "./EntranceTestSchedule.vue?vue&type=script&lang=js"
import style0 from "./EntranceTestSchedule.vue?vue&type=style&index=0&id=1286c884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1286c884",
  null
  
)

export default component.exports